import {Link} from 'react-router-dom';
import {useSelector} from 'react-redux';
import {makeSelectTabOperations} from 'redux/store/auth';
import {NavTabsEnum} from 'utils/constants';
import styles from './performance.module.scss';

// The target lives with the other Customer Support settings in Platform
// Settings, under that page's own permission.
export const SUPPORT_SETTINGS_PATH =
  '/dashboard/app-version-setting?route=AI_SUPPORT';

/** "Change", for viewers who may edit Platform Settings; nothing otherwise. */
export const TargetLink = () => {
  const operations = useSelector(state =>
    makeSelectTabOperations(state, NavTabsEnum.PlatformSettings),
  );
  if (!operations?.update) return null;
  return (
    <Link className={styles.targetLink} to={SUPPORT_SETTINGS_PATH}>
      Change
    </Link>
  );
};
